import styled from 'styled-components';

const cssPropertiesToString = (props: React.CSSProperties): string => {
  return Object.entries(props)
    .map(([key, value]) => {
      const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      return `${cssKey}: ${value};`;
    })
    .join(' ');
};

export const Card = styled.div<{ sx?: React.CSSProperties }>`
  border-radius: 8px;
  box-shadow: 0px 1px 8px 0px var(--color-shadow-card);
  padding: 24px 0;
  ${({ sx }) => sx && cssPropertiesToString(sx)}
`;